<template>
    <modal>
        <template slot="modal-header">
            <div class="header-wrapper">
                <h2 class="section-heading">
                    <template v-if="userId">Edit user</template>
                    <template v-else>Create new user</template>
                </h2>
                <close-button @closeModal="closeModal"></close-button>
            </div>
        </template>
        <template slot="modal-body">
            <vue-form :state="formState" name="userForm" @submit.prevent="" >
                <div class="col-12">
                    <div class="form-row">
                        <validate class="form-group col-12 col-sm-6">
                            <field-messages class="invalid-feedback" name="fname" show="$dirty && $invalid">
                                <div slot="required">First name is required</div>
                            </field-messages>
                            <input type="text" required name="fname" class="form-control" v-model.trim="user.firstName">
                            <label>First name</label>
                        </validate>
                        <validate class="form-group col-12 col-sm-6">
                            <field-messages class="invalid-feedback" name="lname" show="$dirty && $invalid">
                                <div slot="required">Last name is required</div>
                            </field-messages>
                            <input type="text" required name="lname" class="form-control" v-model.trim="user.lastName">
                            <label>Last name</label>
                        </validate>
                    </div>
                    <div class="form-row">
                        <validate class="form-group col-12 col-sm-6">
                            <field-messages class="invalid-feedback" name="email" show="$dirty && $invalid">
                                <div slot="required">Email is required</div>
                                <div slot="email">Email is invalid</div>
                            </field-messages>
                            <input type="email" required :disabled="user.id" name="email" class="form-control" v-model.trim="user.email">
                            <label>Email</label>
                        </validate>
                        <div class="form-group col-12 col-sm-6">
                            <select class="form-control" v-model="user.role">
                                <option v-for="role in roles" :value="role.value" :key="role.name">{{role.name}}</option>
                            </select>
                            <label>Role</label>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-6 col-sm-6">
                            <input type="email" required name="mobile" class="form-control" v-model.trim="user.mobile">
                            <label>Mobile</label>
                        </div>
                        <div class="form-group col-6 col-sm-6">
                            <input type="text" required name="destinationUrl" class="form-control" v-model.trim="user.destinationUrl">
                            <label>Destination URL</label>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-6">
                            <div class="form-group col-12 col-sm-4 no-side-pad">
                                <label><small class="text-light">(Max: 1mb JPG, PNG, GIF, SVG)</small></label>
                                <logo-upload :logo="user.imageOriginal" label="Image" ref="userImage" :displayLabel="false"/>
                                <div class="error" v-if="agentImageSizeError">Agent Image must be 1MB Max Size</div>
                            </div>
                        </div>
                        <validate class="col-6 col-sm-6">
                            <div class="form-group col-12 col-sm-12 no-side-pad">
                                <field-messages class="invalid-feedback" name="postcode" show="$dirty && $invalid">
                                    <div slot="max-list-len">Maximum 4 Territory Postcodes</div>
                                </field-messages>
                                <input type="text" name="postcode" class="form-control" v-model.trim="user.postcode" max-list-len="4"/>
                                <label>Postcode</label>
                            </div>
                        </validate>
                    </div>
                </div>
                <div class="modal-footer">
                    <div>
                        <button class="btn btn-tertiary" v-if="user.id" @click="deleteAction(`Are you sure you want to archive ${user.firstName} ${user.lastName}?`,'Archive')">Archive</button>
                    </div>
                    <div class="c__btn--container">
                        <button class="btn btn-primary" v-if="user.id" @click="updateUser" :disabled="formState.$invalid">Save</button>
                        <button class="btn btn-primary" v-else :disabled="formState.$invalid" @click="createUser">Save</button>
                    </div>
                </div>
            </vue-form>
            <result-message :errors="errors"></result-message>
        </template>
    </modal>
</template>

<script>
    import Modal from '../../helpers/Modal';
    import ResultMessage from '../../helpers/ResultMessage';
    import CloseButton from '../../helpers/CloseButton';
    import UserServices from '../../services/users';
    import DeleteAction from '../../mixins/DeleteAction';
    import LogoUpload from '../../helpers/LogoUpload';
    import FileServices from '../../services/files';

    export default {
        name: 'ModalUser',
        mixins: [DeleteAction],
        props: ["userId", "agency"],
        components: {
            Modal,
            ResultMessage,
            CloseButton,
            LogoUpload
        },
        data () {
            return {
                formState: {},
                agencies: [],
                roles: [
                    {
                        name: 'Office Admin',
                        value: 'ROLE_AGENT_ADMIN'
                    },
                    {
                        name: 'Agent',
                        value: 'ROLE_AGENT_USER'
                    }
                ],
                user: {
                    selectedPermissions: []
                },
                errors: {
                    type: Object|Error,
                    $clean: true
                },
                agentImageSizeError: false,
                postcodeError: false
            }
        },
        methods: {
            closeModal() {
                this.$emit("closeModal");
            },
            getUser () {
                UserServices.getUser(this.userId, 'company')
                    .then(user => {
                        this.user = user;
                        this.user.role = this.user.role.value;
                        this.user.selectedClient = {};
                        if (typeof this.user.client !== 'undefined') {
                            self.user.selectedClient = this.user.client
                        }
                    });
            },
            deleteItem() {
                UserServices.archiveUser(this.user.id).then(user => {
                    this.user = user.data;
                    this.$emit('closeModal');
                }).catch((errors) => {
                    this.errors = errors;
                });
            },
            async updateUser() {
                this.agencies.push(this.agency);
                if(this.userImageError()) {
                    return;
                }
                await this.uploadUserImage();
                UserServices
                    .setAgencies(this.agencies)
                    .updateUser(this.user).then(() => {
                        this.$emit('closeModal');
                }).catch((errors) => {
                    this.errors = errors;
                });
            },
            async createUser() {
                this.user.username = this.user.email;
                this.user.selectedPermissions = [];
                this.agencies.push(this.agency);
                this.user.selectedPermissions.push(this.agency.id);
                if(this.userImageError()) {
                    return;
                }
                await this.uploadUserImage();
                UserServices
                    .setAgencies(this.agencies)
                    .createUser(this.user).then(user => {
                        // Set user id since its a new user and its needed for uploadUserImage
                        this.user.id = user.id;
                        this.$emit('closeModal');
                }).catch((errors) => {
                    this.errors = errors;
                });
            },
            userImageError() {
                this.agentImageSizeError = false;
                if(this.$refs.userImage) {
                    if (this.$refs.userImage.uploadFile.size > 1024000) {
                        this.agentImageSizeError = true;
                    }
                }
                return this.agentImageSizeError;
            },
            async uploadUserImage() {
                let formData = null;
                if (this.$refs.userImage && typeof this.$refs.userImage.uploadFile.size !== 'undefined') {
                    formData = new FormData();
                    formData.append('image', this.$refs.userImage.uploadFile);
                    formData.append('subType', 'agent original');
                } else if(this.user.imageOriginal && this.user.imageOriginal.id) {
                    this.user.imageOriginal = this.user.imageOriginal.id;
                }
                if (formData) {
                    await FileServices.uploadFile(formData).then(userImage => {
                        this.user.imageOriginal = userImage.id;
                    }).catch((errors) => {
                        this.errors = errors;
                    });
                }
            },
        },
        mounted () {
            if (this.userId !== null){
                this.getUser();
            }
        }
    }
</script>
